import { render } from "./refresh_ip_token.vue?vue&type=template&id=604b8697"
import script from "./refresh_ip_token.vue?vue&type=script&lang=js"
export * from "./refresh_ip_token.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__